import React from 'react';

export default function PoiAction(props){
  let {poi, city, onAdd, onRemove, addActionBtnText} = props;
  if(onAdd){
    return(
      <div className="action-wrap add-to-trip" onClick={() => onAdd(poi, city)}>
        { !addActionBtnText && <i className="icon icon-add-bold" /> }
        <div className="add-to-trip-btn">{addActionBtnText || '加入行程'}</div>
      </div>
    );
  }

  if(onRemove){
    return(
      <div className="action-wrap" onClick={() => onRemove(poi, city)}>
        <div className="add-to-trip-btn">移出行程</div>
      </div>
    );
  }  

  return null;
  
}


// WEBPACK FOOTER //
// ./src/components/Poi2/Introduction/PoiAction.js